/**
 * Module Federation async boundary.
 *
 * This file is the build entry point. It dynamically imports the actual
 * application bootstrap so that Module Federation's shared dependency
 * negotiation can complete before any React code runs.
 *
 * All application logic lives in ./bootstrap.tsx.
 */
import('./bootstrap')
